import React from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MUIDataTable from "mui-datatables";
import Chip from "@mui/material/Chip";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import NewCustomer from "./Components/NewCustomer";
import Customer from "./Components/Customer";
import useSave from "../../Hooks/useSave";
import { useEffect } from "react";
import { useState } from "react";
import useDatatableAddon from "../../Hooks/useDatatableAddon";
import IconMenu from "../../components/subMenu/SubMenu";
import { Paper } from "@mui/material";

export default function CustomerGroups() {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchGraphql, DialogSave } = useSave();
  const [customers, setCustomers] = useState([]);

  const menuHeader = {
    icon: "",
    name: "Customers",
  };

  const menu = [
    { link: "/customers/customer-groups", name: "Customer Groups" },
    { link: "/customers", name: "Customers" },
  ];

  const addonOptions = {
    open: (tableMeta) => {
      navigate(`/customers/customer/${tableMeta.rowData[0]}/company-info`);
    },
    delete: (tableMeta) => {
      fetchGraphql({
        query: `mutation DeleteCustomer($customerId: ID) {
          deleteCustomer(customerId: $customerId)
        }`,
        variables: { customerId: tableMeta.rowData[0] },
      });
    },
    edit: false,
  };

  const [textField, selectField, newRecord, actions, options] =
    useDatatableAddon(customers, setCustomers, "productId", addonOptions);

  useEffect(() => {
    fetchGraphql({
      query: `query CustomerGroups {
        customerGroups {
          customerId
          customerName
          customerGroupCode
          customerPhoneNumber
          customerEmail
          customerType
        }
      }`,
    }).then((result) => setCustomers(result.data.customerGroups));
  }, [location.pathname === "/customers"]);

  const columns = [
    {
      name: "customerId",
      options: {
        display: false,
      },
    },
    {
      name: "customerName",
      label: "Customer Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            firstRow: true,
            width: "200px",
          };

          return textField(tableMeta, value, options);
        },
      },
    },
    {
      name: "customerPhoneNumber",
      label: "Customer Phone",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "200px",
          };
          return textField(tableMeta, value, options);
        },
      },
    },
    {
      name: "customerEmail",
      label: "Customer Email",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "200px",
          };
          return textField(tableMeta, value, options);
        },
      },
    },
    {
      name: "customerType",
      label: "Customer Type",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "200px",
          };
          return textField(tableMeta, value, options);
        },
      },
    },
    { ...actions },
  ];

  return (
    <Box sx={{ display: "flex", flexDireection: "row", width: "100%" }}>
      <DialogSave />
      <IconMenu menuHeader={menuHeader} menu={menu} />

      <Paper
        sx={{
          width: "100%",
          height: "auto",
          marginLeft: "20px",
          padding: "20px",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Button
          variant="contained"
          sx={{ margin: "0px 0px 20px 0px", marginLeft: "auto" }}
          onClick={() => navigate("/customers/new-customer")}
        >
          <AddIcon />
          New Customer
        </Button>

        <MUIDataTable
          title={"Customers"}
          data={customers}
          columns={columns}
          options={options}
        />
      </Paper>
    </Box>
  );
}
